export default [
    {
      title: 'Quotation',
      icon: 'FileTextIcon',
      tagVariant: 'light-danger',
      route:'quotation'
    },
  ]
  